import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading, generateYearRange, validateButtonASIBlock,getStatusFlagValue,isNumeric} from '../../Custom/Custom';
import titlesData from '../../titles.json';
import asiTitle from '../../asi.json';

function BlockB({
  blockPageInfo,
  config,
  userInfoObject,
  blockInfo,
  accessAsiBlock,
  decode_token
}) {

  
  const navigate = useNavigate();
  const initialFormData = {
    dslNo:  blockInfo.dslNo,
    surveyYear: blockInfo.surveyYear,
    // Name & address of the Industrial undertaking (Point 1)
    villageTown: '',
    districtName: '',
    stateName: '',
    pinCode: '',
    emailId: '',
    mobileNumber: '',
    typeOrgCode: '',
    hasCIN: '',
    typeOwnerCode:'',
    isoCert14000: '',
    yearInitProd: '',
    accountYear: '',
    numberOfMonthsOperation:'',
    compAccSystem: '',
    asiDataCompMedia: '',
    // R&D employee counts (for 2024-2025)
    rdMaleEmployees: '',
    rdFemaleEmployees: '',
    rdTransgenderEmployees: '',
    // Contact person details (for 2024-2025)
    contactPersonName: '',
    contactPersonDesignation: '',
    contactPersonEmail: '',
    contactPersonMobile: '',
    // Training employee counts (for 2024-2025)
    trainingMaleEmployees: '',
    trainingFemaleEmployees: '',
    trainingTransgenderEmployees: '',
    // GSTIN (for 2024-2025)
    gstin: '',
    anyFormalTraining: '',
    statusFlag: ''
}
  const [formData, setFormData] = useState(initialFormData);
  const yearRange=generateYearRange(formData.surveyYear);
  const [buttonStatus,setButtonStatus]=useState('');
  const applyStatusFlagToPostData = (postData, statusFlagValue) => {
    if (!postData || !Array.isArray(postData.itemCodes)) {
      return postData;
    }
    return {
      ...postData,
      itemCodes: postData.itemCodes.map((item) => ({
        ...item,
        statusFlag: statusFlagValue
      }))
    };
  };
  const roleCodes = decode_token?.id?.ROLE_CODE
    ? String(decode_token.id.ROLE_CODE)
        .split('|')
        .map((r) => String(r).trim())
        .filter(Boolean)
    : [];
  const isDivasiRole = roleCodes.includes('DIVASI');
  const isDivasiStatusFlagOne = isDivasiRole && String(formData?.statusFlag ?? '').trim() === '1';
  const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
  const isHqStatusFlagThree = isHqRole && String(formData?.statusFlag ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(formData?.statusFlag ?? '').trim() === '';
  const statusUnitCodeData=localStorage.getItem('statusUnitCode')
  const shouldSkipValidationForNext = ['4', '5', '7','8'].includes(statusUnitCodeData) && blockInfo.surveyYear == '2024';
  const nextBlockId = shouldSkipValidationForNext ? 12 : 3;
  const nextBlockRoute = shouldSkipValidationForNext ? "/BlockL" : "/BlockC";
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
    return Array.isArray(ids) && ids.map(Number).includes(nextBlockId);
  })();
  const [year,setyear]=useState([]);  

 
  const storedLanguage = localStorage.getItem('language');

  useEffect(()=>{
    
   
  // Function to handle page load Form data
  const blockBData= async()=>{


    if(blockInfo.dslNo ==='' ){
      toast.error("Please Enter DSL No.", messages.COLOR_RED);
      return false;
    }

  

    const newObject={
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
    };
    
    try {
      const response = await axios.post(`${API_URL}api/asi/blockBForm`, newObject, config);
      // const response = await axios.post(`https://updesdev.srmtechsol.com/api/asi/blockBForm`, newObject, config);
      // console.log("response====================",response.data);
      const {data,status} = response.data;
          if (status) {
            const blockData=data.blockBData;
            
            // Map typeOrgCode: Convert "01", "02", "07", etc. to "1", "2", "7", etc.
            if (blockData.typeOrgCode) {
              // Remove leading zeros and convert to string
              blockData.typeOrgCode = String(parseInt(blockData.typeOrgCode, 10));
            }
            
            // Normalize dropdown values to strings (for consistency with form validation)
            if (blockData.isoCert14000 !== undefined && blockData.isoCert14000 !== null && blockData.isoCert14000 !== '') {
              blockData.isoCert14000 = String(blockData.isoCert14000);
            }
            if (blockData.compAccSystem !== undefined && blockData.compAccSystem !== null && blockData.compAccSystem !== '') {
              blockData.compAccSystem = String(blockData.compAccSystem);
            }
            // Map rdUnit to asiDataCompMedia if rdUnit exists in API response
            if (blockData.rdUnit !== undefined && blockData.rdUnit !== null && blockData.rdUnit !== '') {
              blockData.asiDataCompMedia = String(blockData.rdUnit);
              // Store R&D status in localStorage for BlockG to use
              if (blockData.rdUnit === '3') {
                localStorage.setItem('rdUnitStatus', '3');
              } else {
                localStorage.removeItem('rdUnitStatus');
              }
            } else if (blockData.asiDataCompMedia !== undefined && blockData.asiDataCompMedia !== null && blockData.asiDataCompMedia !== '') {
              blockData.asiDataCompMedia = String(blockData.asiDataCompMedia);
              // Store R&D status in localStorage for BlockG to use
              if (blockData.asiDataCompMedia === '3') {
                localStorage.setItem('rdUnitStatus', '3');
              } else {
                localStorage.removeItem('rdUnitStatus');
              }
            }
            if (blockData.anyFormalTraining !== undefined && blockData.anyFormalTraining !== null && blockData.anyFormalTraining !== '') {
              blockData.anyFormalTraining = String(blockData.anyFormalTraining);
            }
            if (blockData.hasCIN !== undefined && blockData.hasCIN !== null && blockData.hasCIN !== '') {
              blockData.hasCIN = String(blockData.hasCIN);
            }
            
            // Map hasCIN based on typeOwnerCode value
            // If typeOwnerCode has a value, set hasCIN to "1" (Yes), otherwise "2" (No)
            if (blockData.typeOwnerCode && blockData.typeOwnerCode.trim() !== '') {
              blockData.hasCIN = '1';
            } else {
              blockData.hasCIN = '2';
              blockData.typeOwnerCode = ''; // Clear typeOwnerCode if no value
            }
            
            // Initialize new fields for 2024-2025 if not present in API response
            const newFields = {
              // Point 1 fields
              villageTown: blockData.villageTown || '',
              districtName: blockData.districtName || '',
              stateName: blockData.stateName || '',
              pinCode: blockData.pinCode || '',
              emailId: blockData.emailId || '',
              mobileNumber: blockData.mobileNumber || '',
              // R&D employee counts
              rdMaleEmployees: blockData.rdMaleEmployees || '',
              rdFemaleEmployees: blockData.rdFemaleEmployees || '',
              rdTransgenderEmployees: blockData.rdTransgenderEmployees || '',
              // Contact person details
              contactPersonName: blockData.contactPersonName || '',
              contactPersonDesignation: blockData.contactPersonDesignation || '',
              contactPersonEmail: blockData.contactPersonEmail || '',
              contactPersonMobile: blockData.contactPersonMobile || '',
              // Training employee counts
              trainingMaleEmployees: blockData.trainingMaleEmployees || '',
              trainingFemaleEmployees: blockData.trainingFemaleEmployees || '',
              trainingTransgenderEmployees: blockData.trainingTransgenderEmployees || '',
              // GSTIN
              gstin: blockData.gstin || ''
            };
            
            setFormData({ ...blockData, ...newFields })
            const statusFlage = blockData.statusFlag;
            const buttonStatus = await validateButtonASIBlock(decode_token, statusFlage);
            setButtonStatus(buttonStatus);
          }else{
            if(blockInfo.surveyYear==2024){
              getBlockBDataFromIndustryDetail();
            }
          }
    } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
        showAppLoading(false);
    }

  }
  blockBData();
  getSurveyYears()
  },[])


  const getBlockBDataFromIndustryDetail=async()=>{
    const response = await axios.get(`${API_URL}api/asi/masterIndustryDetails?dsl_no=${blockInfo.dslNo}&survey_year=${blockInfo.surveyYear}`, config);

    if(response.status){
      const blockData = response?.data?.data[0];
    

      const newFields = {
        // Point 1 fields
        villageTown: blockData.Address_Unit || '',
        districtName: blockData.District_Name || '',
        stateName: blockData.State_Name || '',
        dslNo: blockInfo.dslNo || '',
        surveyYear: blockInfo.surveyYear || '',
        pinCode: blockData.Pin_Code || '',
       
      };
      
      setFormData(newFields)
    }
   
  }



  const getSurveyYears=async()=>{
    showAppLoading(true)
       try {
          const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
          const allYear = response.data;
         
 
          if (allYear.status) {
              setyear(allYear.data.surveyYearList)
              showAppLoading(false);
          }
    } catch (error) {
       console.error(error);
       showAppLoading(false);
    }finally{
       showAppLoading(false);
    }

}

  // Function to handle PIN Code validation on blur
  const handlePinCodeBlur = (e) => {
    const value = e.target.value;
    // Check if PIN Code is less than 6 digits (but not empty)
    if(value && value.length > 0 && value.length < 6){
      toast.error('Please enter valid PIN Code', messages.COLOR_RED);
    }
  }

  // Function to validate email format
  const isValidEmail = (email) => {
    if (!email || email.trim() === '') {
      return true; // Empty email is allowed (optional field)
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

  // Function to handle Email validation on blur
  const handleEmailBlur = (e) => {
    const value = e.target.value;
    // Check if email is valid (but not empty - empty is allowed)
    if(value && value.trim() !== '' && !isValidEmail(value)){
      toast.error('Please enter valid email address', messages.COLOR_RED);
    }
  }

  // Function to handle Mobile Number validation on blur
  const handleMobileNumberBlur = (e) => {
    const value = e.target.value;
    // Check if mobile number is exactly 10 digits (but not empty - empty is allowed)
    if(value && value.length > 0 && value.length !== 10){
      toast.error('Please enter valid 10 digit mobile number', messages.COLOR_RED);
    }
  }

  // Function to handle State on change
  const handleChange = (e) => {
      const { name, value } = e.target;
      let sanitizedValue = value;

      // Removed typeOrgCode validation from handleChange as it's now a dropdown
      
      // Validate Year of Initial Production (4 digits, numeric only)
      if(name === 'yearInitProd'){
        if(value && !/^\d*$/.test(value)){
          toast.error('Year of Initial Production should be numeric.', messages.COLOR_RED);
          return false;
        }
        if(value.length > 4){
          sanitizedValue = value.substring(0, 4);
        }
      }
     
      // Validate numeric fields for R&D and Training employees (max 6 digits)
      const numericFields = ['rdMaleEmployees', 'rdFemaleEmployees', 'rdTransgenderEmployees', 
                            'trainingMaleEmployees', 'trainingFemaleEmployees', 'trainingTransgenderEmployees',
                            'numberOfMonthsOperation'];
      if (numericFields.includes(name)) {
        if(value && !/^\d*$/.test(value)) {
          toast.error('Please enter numeric value only.', messages.COLOR_RED);
          return false;
        }
        // Limit to 6 digits for employee counts, 2 digits for months
        if(name === 'numberOfMonthsOperation' && value.length > 2){
          sanitizedValue = value.substring(0, 2);
        } else if(value.length > 6){
          sanitizedValue = value.substring(0, 6);
        }
      }
      
      // Validate PIN code (6 digits, numeric only)
      if (name === 'pinCode') {
        if(value && !/^\d*$/.test(value)) {
          toast.error('PIN Code should be numeric only.', messages.COLOR_RED);
          return false;
        }
        if(value.length > 6){
          sanitizedValue = value.substring(0, 6);
        }
      }
      
      // Validate mobile numbers (10 digits, numeric only)
      const mobileFields = ['contactPersonMobile', 'mobileNumber'];
      if (mobileFields.includes(name)) {
        if(value && !/^\d*$/.test(value)) {
          toast.error('Mobile number should be numeric only.', messages.COLOR_RED);
          return false;
        }
        if(value.length > 10){
          sanitizedValue = value.substring(0, 10);
        }
      }
      
      // Validate text fields (name, address, designation) - letters, spaces, dots, hyphens only, max 100 chars
      const textFields = ['villageTown', 'districtName', 'stateName', 'contactPersonName', 'contactPersonDesignation'];
      if (textFields.includes(name)) {
        // Allow letters, spaces, dots, hyphens, and common punctuation
        const textOnlyValue = value.replace(/[^a-zA-Z\s\.\-\'\(\)]/g, '');
        if(value !== textOnlyValue) {
          toast.error(`${name === 'contactPersonName' ? 'Name' : name === 'contactPersonDesignation' ? 'Designation' : 'Field'} should contain only letters, spaces, dots, and hyphens.`, messages.COLOR_RED);
          return false;
        }
        if(value.length > 100){
          sanitizedValue = value.substring(0, 100);
        }
      }
      
      // Validate email fields
      const emailFields = ['emailId', 'contactPersonEmail'];
      if (emailFields.includes(name)) {
        if(value && value.length > 100){
          sanitizedValue = value.substring(0, 100);
        }
        // Email format validation will be done on blur or submit
        // Note: Basic format check is done in handleEmailBlur and validateForm
      }
      
      // Validate GSTIN (15 characters, alphanumeric)
      if (name === 'gstin') {
        const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
        if(value !== alphanumericValue) {
          toast.error('GSTIN should contain only alphanumeric characters.', messages.COLOR_RED);
          return false;
        }
        if(value.length > 15){
          sanitizedValue = value.substring(0, 15);
        }
      }
      
      // Validate CIN (21 characters, alphanumeric) - already has validation but ensure max length
      if (name === 'typeOwnerCode' && value.length > 21){
        sanitizedValue = value.substring(0, 21);
      }
     
      if (name === 'accountYear' &&  formData.surveyYear < value) {
        toast.error(messages.ACCOUNTING_YEAR_MSG, messages.COLOR_RED);
        return false;
     }

     // If user selects "No" for CIN, clear the CIN field
     if (name === 'hasCIN' && value === '2') {
        setFormData({ ...formData, [name]: value, typeOwnerCode: '' });
     } 
     // If user selects "No" (3) for asiDataCompMedia (R&D), clear all R&D fields
     else if (name === 'asiDataCompMedia' && value === '3') {
        setFormData({ 
          ...formData, 
          [name]: sanitizedValue,
          rdMaleEmployees: '',
          rdFemaleEmployees: '',
          rdTransgenderEmployees: ''
        });
        // Store R&D status in localStorage for BlockG to use
        localStorage.setItem('rdUnitStatus', '3');
     } else if (name === 'asiDataCompMedia' && (value === '1' || value === '2')) {
        // If user selects "Yes" (1 or 2), update state and remove the flag
        setFormData({ 
          ...formData, 
          [name]: sanitizedValue
        });
        localStorage.removeItem('rdUnitStatus');
     }
     // If user selects "No" (2) for anyFormalTraining, clear all training fields
     else if (name === 'anyFormalTraining' && value === '2') {
        setFormData({ 
          ...formData, 
          [name]: sanitizedValue,
          trainingMaleEmployees: '',
          trainingFemaleEmployees: '',
          trainingTransgenderEmployees: ''
        });
     } else {
        setFormData({ ...formData, [name]: sanitizedValue });
     }
  }

  const handleNext= async()=>{
  const shouldSkipValidation = ['4', '5', '7','8'].includes(statusUnitCodeData) && blockInfo.surveyYear == '2024';
      // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
      if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
        navigate(nextBlockRoute);
        return;
      }
      // DIVASI + statusFlag=1: do not save, just navigate
      if (isDivasiStatusFlagOne) {
        if (shouldSkipValidation) {
          navigate("/BlockL");
        } else {
          navigate("/BlockC");
        }
        return;
      }
      // HQADM/HQASI + statusFlag=3: do not save, just navigate
      if (isHqStatusFlagThree) {
        if (shouldSkipValidation) {
          navigate("/BlockL");
        } else {
          navigate("/BlockC");
        }
        return;
      }
      const confirmed = window.confirm("Have you saved your changes?");
      if (!confirmed) return;
      if(statusUnitCodeData==='5'){
        const saveResult = await handleSaveData("SAVE");
        if(saveResult){
           // IMPORTANT: wait for blockValidation so access ids update before navigation
           await blockValidation()
           if(shouldSkipValidation){
          
            navigate("/BlockL")
           }else{
            navigate("/BlockC")
           }
          
         }
         
         
     }else{
        const saveResult = await handleSaveData("SAVE");
        if (saveResult) {
           // IMPORTANT: wait for blockValidation so access ids update before navigation
           await blockValidation()
           if(shouldSkipValidation){
           
            navigate("/BlockL")
           }else{
            // status 2/3 -> BlockC (same as default)
            navigate("/BlockC")
           }
        }
      }
    
   }


   //All block validation Data
 const  blockValidation=async()=>{

  let  postData= {
      dsl_no: formData.dslNo,
      survey_year:  formData.surveyYear,
      statusUnitCode: statusUnitCodeData
    }

 try {
     showAppLoading(true);
     const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
     const {data,status} = response.data;
     const accessIds=data.allblockData
     console.log("accessIds", accessIds)
      if(accessIds.length>0){
         if(accessIds.length > [1,2,3].length){
            accessAsiBlock(accessIds)
          }else{
            accessAsiBlock([1,2,3])
          }
      }else{
          accessAsiBlock([1,2,3])
      }
      showAppLoading(false);
       return true;

     } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
    
   }

}


  const handlePrevious=()=>{
    
   const confirmed = window.confirm("Have you saved your changes?");
    if (confirmed) {
        navigate("/BlockA")
    }
 }

// Function to handle reset Form Data
  const handleReset=()=>{
     setFormData(initialFormData);
   }

// Function to handle validate Form Data - Serial number wise validation (one at a time)
  const validateForm = () => {
    const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
    
    // Step 1: Validate 1.4 PIN Code (if 2024 year)
    if (is2024Year) {
      if (formData.pinCode && String(formData.pinCode).trim() !== '') {
        const pinCodeStr = String(formData.pinCode).trim();
        if (!/^\d{6}$/.test(pinCodeStr)) {
          toast.error('1.4 Please enter valid PIN Code', messages.COLOR_RED);
          return false;
        }
      }
      
      // Step 2: Validate 1.5 Email Id
      if (formData.emailId && String(formData.emailId).trim() !== '') {
        const emailStr = String(formData.emailId).trim();
        if (!isValidEmail(emailStr)) {
          toast.error('1.5 Please enter valid email address', messages.COLOR_RED);
          return false;
        }
      }
      
      // Step 3: Validate 1.6 Mobile Number
      if (formData.mobileNumber && String(formData.mobileNumber).trim() !== '') {
        const mobileStr = String(formData.mobileNumber).trim();
        if (!/^\d{10}$/.test(mobileStr)) {
          toast.error('1.6 Please enter valid 10 digit mobile number', messages.COLOR_RED);
          return false;
        }
      }
    }
    
    // Step 4: Validate 2. Type of Organization Code
    const typeOrgCodeValue = formData.typeOrgCode;
    const normalizedTypeOrgCode = String(typeOrgCodeValue);
    if (!['1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(normalizedTypeOrgCode)) {
      toast.error('2. Please select Type of Organization Code.', messages.COLOR_RED);
      return false;
    }
    
    // Step 5: Validate 3. CIN (hasCIN)
    const hasCINValue = formData.hasCIN;
    const normalizedHasCIN = String(hasCINValue);
    if (normalizedHasCIN !== '1' && normalizedHasCIN !== '2') {
      toast.error('3. ' + (storedLanguage === 'hi' ? 'कृपया CIN है या नहीं चुनें' : 'Please select whether you have CIN or not'), messages.COLOR_RED);
      return false;
    }
    
    // Step 6: Validate 3. CIN Number (if hasCIN is Yes)
    if (normalizedHasCIN === '1') {
      const typeOwnerCodeValue = formData.typeOwnerCode || '';
      const cinLen = typeOwnerCodeValue.length;
      
      if (cinLen === 0 || cinLen === '') {
        toast.error('3. Please Enter Corporate Identification Number (CIN)', messages.COLOR_RED);
        return false;
      }
      
      if (!/^[a-zA-Z0-9]+$/.test(typeOwnerCodeValue)) {
        toast.error('3. Corporate Identification Number (CIN) alphanumeric characters only.', messages.COLOR_RED);
        return false;
      }
      
      if (cinLen !== 21) {
        toast.error('3. ' + messages.TYPE_OWNER_21_CHARCTER_MSG, messages.COLOR_RED);
        return false;
      }
    }
    
    // Step 7: Validate 4. ISO 14000 Certification
    const isoCertValue = formData.isoCert14000;
    const normalizedIsoCert = String(isoCertValue);
    if (normalizedIsoCert !== '1' && normalizedIsoCert !== '2') {
      toast.error('4. Please select ISO 14000 Certification.', messages.COLOR_RED);
      return false;
    }
    
    // Step 8: Validate 5. Year of Initial Production
    const yearInitProdValue = formData.yearInitProd;
    if (yearInitProdValue === "" || yearInitProdValue === null || yearInitProdValue === undefined) {
      toast.error('5. Enter Year of Initial Production.', messages.COLOR_RED);
      return false;
    }
    
    if (!/^\d{4}$/.test(String(yearInitProdValue))) {
      toast.error('5. Year of Initial Production should be a four-digit number.', messages.COLOR_RED);
      return false;
    }
    
    if (formData.surveyYear < yearInitProdValue) {
      toast.error('5. ' + messages.ACCOUNTING_YEAR_MSG, messages.COLOR_RED);
      return false;
    }
    
    // Step 9: Validate 6. Accounting Year
    const accountYearValue = formData.accountYear;
    if (accountYearValue === "" || accountYearValue === null || accountYearValue === undefined) {
      toast.error('6. ' + messages.ACCOUNT_YEAR_MSG, messages.COLOR_RED);
      return false;
    }
    
    // Step 10: Validate 7. Number Of Months Operation
    const numberOfMonthsValue = formData.numberOfMonthsOperation;
    if (numberOfMonthsValue === '' || numberOfMonthsValue === null || numberOfMonthsValue === undefined) {
      toast.error('7. Please Enter Number Of Months Operation', messages.COLOR_RED);
      return false;
    }
    
    if (isNaN(numberOfMonthsValue) || numberOfMonthsValue < 1 || numberOfMonthsValue > 12) {
      toast.error('7. Number Of Months Operation is out of range.', messages.COLOR_RED);
      return false;
    }
    
    // Step 11: Validate 8. Whether the share capital includes share of foreign entities
    const compAccSystemValue = formData.compAccSystem;
    const normalizedCompAccSystem = String(compAccSystemValue);
    if (normalizedCompAccSystem !== '1' && normalizedCompAccSystem !== '2') {
      toast.error('8. Please select whether the share capital of the company includes share of foreign entities.', messages.COLOR_RED);
      return false;
    }
    
    // Step 12: Validate 9. Any R & D unit in your factory
    const asiDataCompMediaValue = formData.asiDataCompMedia;
    const normalizedAsiDataCompMedia = String(asiDataCompMediaValue);
    if (normalizedAsiDataCompMedia !== '1' && normalizedAsiDataCompMedia !== '2' && normalizedAsiDataCompMedia !== '3') {
      toast.error('9. Please select a valid option for Any R & D unit in your factory.', messages.COLOR_RED);
      return false;
    }
    
    // Step 12.1: If asiDataCompMedia is "1" or "2" (Yes), at least one R&D field must be filled
    if ((normalizedAsiDataCompMedia === '1' || normalizedAsiDataCompMedia === '2') && is2024Year) {
      const rdMale = String(formData.rdMaleEmployees || '').trim();
      const rdFemale = String(formData.rdFemaleEmployees || '').trim();
      const rdTransgender = String(formData.rdTransgenderEmployees || '').trim();
      
      // Check if at least one field has a value greater than 0
      const hasRdData = (rdMale !== '' && parseFloat(rdMale) > 0) ||
                        (rdFemale !== '' && parseFloat(rdFemale) > 0) ||
                        (rdTransgender !== '' && parseFloat(rdTransgender) > 0);
      
      if (!hasRdData) {
        toast.error('9. Please enter at least one value in 9.1 Male, 9.2 Female, or 9.3 Transgender fields', messages.COLOR_RED);
        return false;
      }
    }
    
    // Step 13: Validate 11. Whether the unit offered any formal training
    const anyFormalTrainingValue = formData.anyFormalTraining;
    const normalizedAnyFormalTraining = String(anyFormalTrainingValue);
    if (normalizedAnyFormalTraining !== '1' && normalizedAnyFormalTraining !== '2') {
      toast.error('11. ' + messages.ANY_FORMAL_TRANNING_MSG, messages.COLOR_RED);
      return false;
    }
    
    // Step 13.1: If anyFormalTraining is "1" (Yes), at least one training field must be filled
    if (normalizedAnyFormalTraining === '1' && is2024Year) {
      const trainingMale = String(formData.trainingMaleEmployees || '').trim();
      const trainingFemale = String(formData.trainingFemaleEmployees || '').trim();
      const trainingTransgender = String(formData.trainingTransgenderEmployees || '').trim();
      
      // Check if at least one field has a value greater than 0
      const hasTrainingData = (trainingMale !== '' && parseFloat(trainingMale) > 0) ||
                              (trainingFemale !== '' && parseFloat(trainingFemale) > 0) ||
                              (trainingTransgender !== '' && parseFloat(trainingTransgender) > 0);
      
      if (!hasTrainingData) {
        toast.error('11. Please enter at least one value in 11.1 Male, 11.2 Female, or 11.3 Transgender fields', messages.COLOR_RED);
        return false;
      }
    }
    
    // Step 14: Validate 10.3 Contact Person Email Id (if 2024 year)
    if (is2024Year) {
      if (formData.contactPersonEmail && String(formData.contactPersonEmail).trim() !== '') {
        const contactEmailStr = String(formData.contactPersonEmail).trim();
        if (!isValidEmail(contactEmailStr)) {
          toast.error('10.3 Please enter valid email address', messages.COLOR_RED);
          return false;
        }
      }
      
      // Step 15: Validate 10.4 Contact Person Mobile Number
      if (formData.contactPersonMobile && String(formData.contactPersonMobile).trim() !== '') {
        const contactMobileStr = String(formData.contactPersonMobile).trim();
        if (!/^\d{10}$/.test(contactMobileStr)) {
          toast.error('10.4 Please enter valid 10 digit mobile number', messages.COLOR_RED);
          return false;
        }
      }
    }
   
   return true;
  
  }
  

// Function to handle update and save form data0
  const handleSaveData = async(buttonType) => {
 
    // Skip validation if surveyYear is '2024' AND statusUnitCodeData is in ['4', '5', '7', '8']
         const shouldSkipValidation = ['4', '5', '7','8'].includes(statusUnitCodeData) && blockInfo.surveyYear == '2024';
            
            if(!shouldSkipValidation){
              if( !validateForm() ){
                console.log(' not value 4, 5, 7, 8');
                return false;
                }

            }else{
              console.log(' 4, 5, 7, 8');
            }
                  


           showAppLoading(true);
           const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
           
           // Clear R&D fields if asiDataCompMedia is "3" (No)
           // Clear training fields if anyFormalTraining is "2" (No)
           let dataToSave = { ...formData };
           
           // Map asiDataCompMedia to rdUnit for backend
           // rdUnit will always be the same as asiDataCompMedia value ("1", "2", or "3")
           if (dataToSave.asiDataCompMedia === '3') {
             dataToSave.rdMaleEmployees = '';
             dataToSave.rdFemaleEmployees = '';
             dataToSave.rdTransgenderEmployees = '';
           }
           
           // Set rdUnit to the selected value from dropdown ("1", "2", or "3")
           dataToSave.rdUnit = dataToSave.asiDataCompMedia || '';
           
           // Update localStorage for BlockG based on rdUnit value
           if (dataToSave.rdUnit === '3') {
             localStorage.setItem('rdUnitStatus', '3');
           } else {
             localStorage.removeItem('rdUnitStatus');
           }
           
           if (dataToSave.anyFormalTraining === '2') {
             dataToSave.trainingMaleEmployees = '';
             dataToSave.trainingFemaleEmployees = '';
             dataToSave.trainingTransgenderEmployees = '';
           }
           
           if (dataToSave.anyFormalTraining === '2') {
             dataToSave.trainingMaleEmployees = '';
             dataToSave.trainingFemaleEmployees = '';
             dataToSave.trainingTransgenderEmployees = '';
           }
           
           const { statusUnitCode, ...modifiedObject }  = {
            ...dataToSave, 
             statusFlag:clickButtonStatusFlag
           };
           const newObject={
              itemCodes:modifiedObject,
              payload:{
                dsl_no: formData.dslNo,
                survey_year: formData.surveyYear,
                buttonType:buttonType
              }
            }
            try {
              const response = await axios.post(`${API_URL}api/asi/blockBFormSaveToDB`, newObject, config);
              const {status,message} = response.data;
              if (status) {

                if(shouldSkipValidation){
                   saveStaticData(clickButtonStatusFlag)
                }else{
                  blockValidation();
                }
               
                toast.success(message, messages.COLOR_RED);
                return true;
              }
        } catch (error) {
            console.error(error);
            toast.error('An error occurred while processing your request.', messages.COLOR_RED);
        } finally {
          if(!shouldSkipValidation){
            showAppLoading(false);
          }
           
       }
       return false;
   }



  const saveStaticData=async(clickButtonStatusFlag)=>{
    showAppLoading(true);
const urlWithPayload = {
  "urls": [
    {
      "name": "blockCFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 140,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 141,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": 2024,
              "assetCode": 142,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
                  "surveyYear": formData.surveyYear,
              "assetCode": 143,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 144,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 145,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
                "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 146,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 147,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 148,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 149,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 150,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": 303678,
              "surveyYear": 2024,
              "assetCode": 151,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 152,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          },
          {
              "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
              "assetCode": 153,
              "openingAsOn": "0",
              "dueToRevaluation": "0",
              "actualAdditions": "0",
              "deductionAdjDuringYear": "0",
              "closingAsOn3456": "0",
              "uptoYearBeginning": "0",
              "providedDuringYear": "0",
              "adjForSoldDiscardedDuringYear": "0",
              "uptoYearEnd": "0",
              "openingAsOn38": "0",
              "closingAsOn711": "0",
              "statusFlag": clickButtonStatusFlag
          }
      ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    {
      "name": "blockDFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 21,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 22,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 23,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 24,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 25,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 26,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 27,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 28,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 29,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 30,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 31,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
              "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 32,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 33,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 34,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 35,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 36,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 37,
            "statusFlag": "7",
            "openingAmount": 0,
            "closingAmount": 0
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    {
      "name": "blockEFormSaveDB",
      "postData": {
        "itemCodes": [
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 95,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 96,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
              "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 97,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 98,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 99,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 100,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 101,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 102,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 103,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 104,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 105,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
              "surveyYear": formData.surveyYear,
            "catagoryId": 106,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 107,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 108,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 109,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 110,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
              "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 111,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 112,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 113,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "catagoryId": 114,
            "manufacturing": 0,
            "nonmanufacturing": 0,
            "total": 0,
            "avgNoPersonsWorked": 0,
            "noMandaysPaid": 0,
            "wagesOrSalaries": 0,
            "statusFlag": "7"
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    {
      "name": "blockFFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1646,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1647,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1648,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1649,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1650,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1651,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
           "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1652,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1653,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1654,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1655,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
              "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1656,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
           "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1657,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1658,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1659,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1660,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1661,
            "expenditure": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": 1662,
            "expenditure": 0,
            "statusFlag": "7"
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    {
      "name": "blockGFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
            "itemCode": 81,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 82,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 83,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 84,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 85,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 86,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 87,
            "recipts": "0",
            "statusFlag": "7"
          },
          {
            "itemCode": 88,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 89,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 90,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 91,
            "recipts": 0,
            "statusFlag": "7"
          },
          {
            "itemCode": 92,
            "recipts": 0,
            "statusFlag": "7"
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    {
      "name": "blockHFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9920100",
            "itemDesc": "Other basic items(indigenous)",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 1,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9990100",
            "itemDesc": "Total Basic Items(1 to 11)",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 2,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9920300",
            "itemDesc": "Non-basic Chemicals-All kinds",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 3,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9990800",
            "itemDesc": "Packing items",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 4,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9990400",
            "itemDesc": "Electricity own generated",
            "unitOfQty": "KWH",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 5,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9990500",
            "itemDesc": "Electricity purchased & consumed",
            "unitOfQty": "KWH",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 6,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9990600",
            "itemDesc": "Petrol, Diesel, Oil, Lubricants, Consumed",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 7,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9990700",
            "itemDesc": "Coal Consumed",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 8,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9990900",
            "itemDesc": "Gas consumed",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 9,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9920400",
            "itemDesc": "Other fuel consumed",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 10,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9922000",
            "itemDesc": "Consumable store",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 11,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9992000",
            "itemDesc": "Total Non-basic items(13 to 21)",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 12,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9993000",
            "itemDesc": "Total Input(12 + 22)",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 13,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "srno": 0,
            "itemCode": "9999900",
            "itemDesc": "Any additional requirement of electricity(unmet demand)",
            "unitOfQty": "",
            "qtyConsumed": 0,
            "purchaseValue": 0,
            "ratePerUnit": 0,
            "saveOrderBy": 14,
            "statusFlag": "7"
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    {
      "name": "blockIFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": "9922100",
            "itemDesc": "Other imported items",
            "purchaseValue": 0,
            "qtyConsumed": 0,
            "ratePerUnit": 0,
            "unitOfQty": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": "9994000",
            "itemDesc": "Total Imports (consumed) (items 1 to 6)",
            "purchaseValue": 0,
            "qtyConsumed": 0,
            "ratePerUnit": 0,
            "unitOfQty": 0,
            "statusFlag": "7"
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    { 
      "name": "blockJFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": "",
            "itemDesc": "",
            "unitOfQty": 0,
            "qtyManufactured": 0,
            "qtySold": 0,
            "grossSaleValue": 0,
            "perunitNetsaleValue": 0,
            "exfactoryValueQty": 0,
            "distributiveExpensesExciseDuty": 0,
            "distributiveExpensesSalesTaxVat": 0,
            "distributiveExpensesOthers": 0,
            "distributiveExpensesTotal": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": "9921100",
            "itemDesc": "Other products/by-products",
            "unitOfQty": 0,
            "qtyManufactured": 0,
            "qtySold": 0,
            "grossSaleValue": 0,
            "perunitNetsaleValue": 0,
            "exfactoryValueQty": 0,
            "distributiveExpensesExciseDuty": 0,
            "distributiveExpensesSalesTaxVat": 0,
            "distributiveExpensesOthers": 0,
            "distributiveExpensesTotal": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": "9995000",
            "itemDesc": "Total (items 1 to 11)",
            "unitOfQty": 0,
            "qtyManufactured": 0,
            "qtySold": 0,
            "grossSaleValue": 0,
            "perunitNetsaleValue": 0,
            "exfactoryValueQty": 0,
            "distributiveExpensesExciseDuty": 0,
            "distributiveExpensesSalesTaxVat": 0,
            "distributiveExpensesOthers": 0,
            "distributiveExpensesTotal": 0,
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "itemCode": "9999900",
            "itemDesc": "Share (%) of products/by-products directly exported",
            "unitOfQty": 0,
            "qtyManufactured": 0,
            "qtySold": 0,
            "grossSaleValue": 0,
            "perunitNetsaleValue": 0,
            "exfactoryValueQty": 0,
            "distributiveExpensesExciseDuty": 0,
            "distributiveExpensesSalesTaxVat": 0,
            "distributiveExpensesOthers": 0,
            "distributiveExpensesTotal": 0,
            "statusFlag": "7"
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    },
    {
      "name": "blockKFormSaveToDB",
      "postData": {
        "itemCodes": [
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "code": "",
            "ictIndicatorCode": 12,
            "ItemsName": "Did the factory use computers during FY 2024–25?",
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "code": "",
            "ictIndicatorCode": 13,
            "ItemsName": "Did the factory use the internet during FY 2024–25?",
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "code": "",
            "ictIndicatorCode": 14,
            "ItemsName": "Did the factory have a website as on the date of survey?",
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "code": "",
            "ictIndicatorCode": 15,
            "ItemsName": "Did the factory receive orders via the internet during FY 2024–25?",
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "code": "",
            "ictIndicatorCode": 16,
            "ItemsName": "Did the factory place orders for business purposes via the internet during FY 2024–25?",
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "code": "",
            "ictIndicatorCode": 17,
            "ItemsName": "Did the factory connect to the internet either by: a. Narrowband, or b. Fixed broadband, or c. Mobile broadband during FY 2024–25?",
            "statusFlag": "7"
          },
          {
            "dslNo": formData.dslNo,
            "surveyYear": formData.surveyYear,
            "code": "",
            "ictIndicatorCode": 18,
            "ItemsName": "Does the factory have a local area network (LAN) as on the date of survey?",
            "statusFlag": "7"
          }
        ],
        "payload": {
          "dsl_no": formData.dslNo,
          "survey_year": formData.surveyYear,
          "buttonType": "SAVE"
        }
      }
    }
  ]
}




      for(let i=0;i<urlWithPayload.urls.length;i++){
        // console.log("urlWithPayload[i]", urlWithPayload.urls[i].name)
        // console.log("urlWithPayload[i].postData", urlWithPayload.urls[i].postData)
        const postDataWithStatusFlag = applyStatusFlagToPostData(
          urlWithPayload.urls[i].postData,
          clickButtonStatusFlag
        );
        const response = await axios.post(`${API_URL}api/asi/${urlWithPayload.urls[i].name}`, postDataWithStatusFlag, config);
        // const {status,message} = response.data;
        // if (status) {
          // toast.success(message, messages.COLOR_RED);
          // return true;
        // }
      }
      blockValidation();
      // setTimeout(() => {
      //   blockValidation();
      // }, 500);
    showAppLoading(false);
    // return false;
  }



  return (
       <div className="card-body">
         {/* <ToastContainer/> */}
              <h4 className="page_heading border-bottom-0">
                 <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_B_TITLE : asiTitle.en.BLOCK_B_TITLE }} />
               </h4>
             
              <div className="row">
                  <div className="col-12 mb-3">
                     <h6 className="fw-semibold">
                     {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{formData.dslNo}</span> 
                     {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
                    </h6>
              </div>
             
              {/* Point 1: Name & address of the Industrial undertaking - Show only for 2024-2025 */}
              {(() => {
                const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                
                if (is2024Year) {
                  return (
                    <>
                      <div className="col-12 mb-2 mt-3">
                        <h6 className="fw-semibold text-muted">1. {storedLanguage === 'hi' ? 'औद्योगिक उपक्रम का नाम और पता' : 'Name & address of the Industrial undertaking'}</h6>
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <label htmlFor="villageTown">1.1 {storedLanguage === 'hi' ? 'गाँव/शहर' : 'Vill./Town'}</label>
                        <input 
                          type="text" 
                          className="form-control"
                          id="villageTown"
                          name="villageTown"
                          maxLength="50"
                          value={formData.villageTown}
                          onChange={handleChange}
                          placeholder="Village/Town"
                          
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <label htmlFor="districtName">1.2 {storedLanguage === 'hi' ? 'जिला नाम' : 'District name'}</label>
                        <input 
                          type="text" 
                          className="form-control"
                          id="districtName"
                          name="districtName"
                          maxLength="50"
                          value={formData.districtName}
                          onChange={handleChange}
                          placeholder="District name"
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <label htmlFor="stateName">1.3 {storedLanguage === 'hi' ? 'राज्य नाम' : 'State name'}</label>
                        <input 
                          type="text" 
                          className="form-control"
                          id="stateName"
                          name="stateName"
                          maxLength="50"
                          value={formData.stateName}
                          onChange={handleChange}
                          placeholder="State name"
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <label htmlFor="pinCode">1.4 {storedLanguage === 'hi' ? 'पिन कोड' : 'PIN Code'}</label>
                        <input 
                          type="text" 
                          className="form-control"
                          id="pinCode"
                          name="pinCode"
                          maxLength="6"
                          value={formData.pinCode}
                          onChange={handleChange}
                          onBlur={handlePinCodeBlur}
                          placeholder="PIN Code"
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <label htmlFor="emailId">1.5 {storedLanguage === 'hi' ? 'ईमेल आईडी' : 'Email Id'}</label>
                        <input 
                          type="email" 
                          className="form-control"
                          id="emailId"
                          name="emailId"
                          maxLength="65"
                          value={formData.emailId}
                          onChange={handleChange}
                          onBlur={handleEmailBlur}
                          placeholder="Email Id"
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <label htmlFor="mobileNumber">1.6 {storedLanguage === 'hi' ? 'मोबाइल नंबर' : 'Mobile Number'}</label>
                        <input 
                          type="text" 
                          className="form-control"
                          id="mobileNumber"
                          name="mobileNumber"
                          maxLength="10"
                          value={formData.mobileNumber}
                          onChange={handleChange}
                          onBlur={handleMobileNumberBlur}
                          placeholder="Mobile Number"
                        />
                      </div>
                    </>
                  );
                }
                return null;
              })()}
                
                    <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                      <label htmlFor="typeOrgCode">
                        {(() => {
                          const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                          return is2024Year ? '2' : '1';
                        })()}. {storedLanguage === 'hi' ? asiTitle.hi.TYPE_OF_ORGANIZATION_CODE : asiTitle.en.TYPE_OF_ORGANIZATION_CODE}
                      </label>
                      <select 
                        className="form-select"
                        id="typeOrgCode"
                        name="typeOrgCode"
                        value={formData.typeOrgCode}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="1">1 - Individual Proprietorship</option>
                        <option value="2">2 - Partnership</option>
                        <option value="3">3 - Limited Liability Partnership</option>
                        <option value="4">4 - Govt. Company Public</option>
                        <option value="5">5 - Govt. Company Private</option>
                        <option value="6">6 - Non-Govt. Company Public</option>
                        <option value="7">7 - Non-Govt. Company Private</option>
                        <option value="8">8 - Co-operative Society</option>
                        <option value="9">9 - Others (including HUF, Trusts, Wakf Boards, Handlooms, KVIC etc.)</option>
                      </select>
                    </div>
              
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="hasCIN">
                      {(() => {
                        const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                        return is2024Year ? '3' : '2';
                      })()}. {storedLanguage === 'hi' 
                        ? 'क्या आपके पास Corporate Identification Number (CIN) है?' 
                        : 'Do you have Corporate Identification Number (CIN)?'}
                    </label>
                    <select 
                      className="form-select"
                      id="hasCIN"
                      name="hasCIN"
                      value={formData.hasCIN}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">1 - Yes</option>
                      <option value="2">2 - No</option>
                    </select>
                  </div>

                  {formData.hasCIN === '1' && (
                    <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                      <label htmlFor="typeOwnerCode">{(() => {
                        const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                        return is2024Year ? '3' : '3';
                      })()}. {storedLanguage === 'hi' ? asiTitle.hi.CIN : asiTitle.en.CIN}</label>
                      <input 
                        type="text" 
                        className="form-control"
                        id="typeOwnerCode"
                        name="typeOwnerCode"
                        maxLength="24"
                        value={formData.typeOwnerCode}
                        onChange={handleChange}
                      />
                    </div>
                  )}
                  
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="isoCert14000">{(() => {
                      const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                      if (is2024Year) {
                        return formData.hasCIN === '1' ? '4' : '4';
                      } else {
                        return formData.hasCIN === '1' ? '4' : '3';
                      }
                    })()}. {storedLanguage === 'hi' ? asiTitle.hi.ISO_14000_CERTIFICATION : asiTitle.en.ISO_14000_CERTIFICATION}</label>
                    <select 
                      className="form-select"
                      id="isoCert14000"
                      name="isoCert14000"
                      value={formData.isoCert14000}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">1 - Yes</option>
                      <option value="2">2 - No</option>
                    </select>
                  </div>
                  
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="yearInitProd">{(() => {
                      const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                      if (is2024Year) {
                        return formData.hasCIN === '1' ? '5' : '5';
                      } else {
                        return formData.hasCIN === '1' ? '5' : '4';
                      }
                    })()}. {storedLanguage === 'hi' ? asiTitle.hi.YEAR_OF_INITIAL_PRODUCTION : asiTitle.en.YEAR_OF_INITIAL_PRODUCTION}</label>
                    <input 
                    type="text" 
                    className="form-control"
                    id="yearInitProd"
                    name="yearInitProd"
                    maxLength="4"
                    value={formData.yearInitProd}
                    onChange={handleChange}
                    placeholder="YYYY"
                    />
                  </div>
                
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="accountYear">{(() => {
                      const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                      if (is2024Year) {
                        return formData.hasCIN === '1' ? '6' : '6';
                      } else {
                        return formData.hasCIN === '1' ? '6' : '5';
                      }
                    })()}. {storedLanguage === 'hi' ? asiTitle.hi.ACCOUNTING_YEAR : asiTitle.en.ACCOUNTING_YEAR}</label>
                    <div className="row align-items-center">
                        <div className="col-5">
                            <select 
                             className="form-select"
                             id="accountYear"
                             name="accountYear"
                             value={formData.accountYear}
                             onChange={handleChange}
                             >
                            <option value="" className="from-txtbx3">[-Select-]</option>
                            {year.map((yearName, index) => (
                              <option key={index} value={yearName}>
                                {yearName}
                            </option>
                            ))}
                             <option value="2012" className="from-txtbx3">2012</option>
                             <option value="2011" className="from-txtbx3">2011</option>
                             <option value="2010" className="from-txtbx3">2010</option>
                             <option value="2009" className="from-txtbx3">2009</option>
                             <option value="2008" className="from-txtbx3">2008</option>
                            <option value="2007" className="from-txtbx3">2007</option>
                            </select>
                        </div>
                        
                        <div className="col-2 text-center">
                            To
                        </div>
                        
                        <div className="col-5">
                            <input 
                            type="text" 
                            className="form-control" 
                            name="accountYearPlus"
                            value={formData.accountYear? parseInt(formData.accountYear)+1 :''}
                            disabled
                           />
                        </div>
                        
                    </div>
                  </div>
                  
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="numberOfMonthsOperation">{(() => {
                      const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                      if (is2024Year) {
                        return formData.hasCIN === '1' ? '7' : '7';
                      } else {
                        return formData.hasCIN === '1' ? '7' : '6';
                      }
                    })()}. {storedLanguage === 'hi' ? asiTitle.hi.NUMBER_OF_MONTHS_OPERATION : asiTitle.en.NUMBER_OF_MONTHS_OPERATION}</label>
                    <input 
                    type="text" 
                    className="form-control"
                    id="numberOfMonthsOperation"
                    name="numberOfMonthsOperation"
                    maxLength="2"
                    value={formData.numberOfMonthsOperation}
                    onChange={handleChange}
                    placeholder="1-12"
                    />
                  </div>
                  
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="compAccSystem">{(() => {
                      const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                      if (is2024Year) {
                        return formData.hasCIN === '1' ? '8' : '8';
                      } else {
                        return formData.hasCIN === '1' ? '8' : '7';
                      }
                    })()}. {storedLanguage === 'hi' ? asiTitle.hi.WHETHER_THE_SHARE_CAPITAL_OF_THE_COMPANY_INCLUDES_SHARE_OF_FOREIGN_ENTITIES : asiTitle.en.WHETHER_THE_SHARE_CAPITAL_OF_THE_COMPANY_INCLUDES_SHARE_OF_FOREIGN_ENTITIES}</label>
                    <select 
                      className="form-select"
                      id="compAccSystem"
                      name="compAccSystem"
                      value={formData.compAccSystem}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">1 - Yes</option>
                      <option value="2">2 - No</option>
                    </select>
                  </div>
                
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="asiDataCompMedia">{(() => {
                      const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                      if (is2024Year) {
                        return formData.hasCIN === '1' ? '9' : '9';
                      } else {
                        return formData.hasCIN === '1' ? '9' : '8';
                      }
                    })()}. {storedLanguage === 'hi' ? asiTitle.hi.ANY_RD_UNIT_IN_YOUR_FACTORY : asiTitle.en.ANY_RD_UNIT_IN_YOUR_FACTORY}</label>
                    <select 
                      className="form-select"
                      id="asiDataCompMedia"
                      name="asiDataCompMedia"
                      value={formData.asiDataCompMedia}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">1 - Yes & registered with DSIR</option>
                      <option value="2">2 - Yes & registered with others</option>
                      <option value="3">3 - No</option>
                    </select>
                  </div>
                  
                  {/* Point 9 Sub-fields: R&D Employee counts - Show only for 2024-2025 when R&D is Yes (1 or 2) */}
                  {(() => {
                    const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                    const showRdEmployees = is2024Year && (formData.asiDataCompMedia === '1' || formData.asiDataCompMedia === '2');
                    
                    if (showRdEmployees) {
                      return (
                        <>
                          <div className="col-12 mb-2 mt-3">
                            <h6 className="fw-semibold text-muted">{storedLanguage === 'hi' ? 'यदि हाँ और DSIR के साथ पंजीकृत - 1 या हाँ और दूसरों के साथ पंजीकृत - 2, आइटम संख्या 9 में, R&D गतिविधि में लगे कर्मचारियों की संख्या' : 'If yes & registered with DSIR - 1 or yes & registered with others - 2, in item no 9, number of employees engaged in R&D activity'}</h6>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="rdMaleEmployees">9.1 {storedLanguage === 'hi' ? 'पुरुष' : 'Male'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="rdMaleEmployees"
                              name="rdMaleEmployees"
                              maxLength="6"
                              value={formData.rdMaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="rdFemaleEmployees">9.2 {storedLanguage === 'hi' ? 'महिला' : 'Female'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="rdFemaleEmployees"
                              name="rdFemaleEmployees"
                              maxLength="6"
                              value={formData.rdFemaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="rdTransgenderEmployees">9.3 {storedLanguage === 'hi' ? 'ट्रांसजेंडर' : 'Transgender'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="rdTransgenderEmployees"
                              name="rdTransgenderEmployees"
                              maxLength="6"
                              value={formData.rdTransgenderEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                        </>
                      );
                    }
                    return null;
                  })()}
                  
                  {/* Point 10 Sub-fields: Contact Person Details - Show only for 2024-2025 */}
                  {(() => {
                    const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                    
                    if (is2024Year) {
                      return (
                        <div className="col-12 print-keep-together">
                          <div className="row">
                          <div className="col-12 mb-2 mt-3">
                            <h6 className="fw-semibold text-muted">10. {storedLanguage === 'hi' ? 'संपर्क व्यक्ति का विवरण' : 'Details of contact person'}</h6>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="contactPersonName">10.1 {storedLanguage === 'hi' ? 'नाम' : 'Name'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="contactPersonName"
                              name="contactPersonName"
                              maxLength="100"
                              value={formData.contactPersonName}
                              onChange={handleChange}
                              placeholder="Contact person name"
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="contactPersonDesignation">10.2 {storedLanguage === 'hi' ? 'पदनाम' : 'Designation'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="contactPersonDesignation"
                              name="contactPersonDesignation"
                              maxLength="100"
                              value={formData.contactPersonDesignation}
                              onChange={handleChange}
                              placeholder="Designation"
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="contactPersonEmail">10.3 {storedLanguage === 'hi' ? 'ईमेल आईडी' : 'Email Id'}</label>
                            <input 
                              type="email" 
                              className="form-control"
                              id="contactPersonEmail"
                              name="contactPersonEmail"
                              maxLength="100"
                              value={formData.contactPersonEmail}
                              onChange={handleChange}
                              onBlur={handleEmailBlur}
                              placeholder="Email address"
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="contactPersonMobile">10.4 {storedLanguage === 'hi' ? 'मोबाइल नंबर' : 'Mobile Number'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="contactPersonMobile"
                              name="contactPersonMobile"
                              maxLength="10"
                              value={formData.contactPersonMobile}
                              onChange={handleChange}
                              onBlur={handleMobileNumberBlur}
                              placeholder="Mobile number"
                            />
                          </div>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })()}
                  
                  <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                    <label htmlFor="anyFormalTraining">{(() => {
                      const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                      if (is2024Year) {
                        return formData.hasCIN === '1' ? '11' : '11';
                      } else {
                        return formData.hasCIN === '1' ? '10' : '9';
                      }
                    })()}. {storedLanguage === 'hi' ? asiTitle.hi.WHETHER_THE_UNIT_OFFERED_ANY_FORMAL_TRAINING : asiTitle.en.WHETHER_THE_UNIT_OFFERED_ANY_FORMAL_TRAINING}</label>
                          <select 
                         className="form-select"
                         id="anyFormalTraining"
                         name="anyFormalTraining"
                         value={formData.anyFormalTraining}
                         onChange={handleChange}
                          >
                        <option value="">Select</option>
                        <option value="1">1 - Yes</option>
                        <option value="2">2 - No</option>
                    </select>
                  </div>
                  
                  {/* Point 11 Sub-fields: Training Employee counts - Show only for 2024-2025 when Training is Yes (1) */}
                  {(() => {
                    const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                    const showTrainingEmployees = is2024Year && formData.anyFormalTraining === '1';
                    
                    if (showTrainingEmployees) {
                      return (
                        <>
                          <div className="col-12 mb-2 mt-3">
                            <h6 className="fw-semibold text-muted">{storedLanguage === 'hi' ? 'यदि आइटम संख्या 11 में \'हाँ\', औपचारिक प्रशिक्षण प्राप्त करने वाले कर्मचारियों की संख्या' : 'If \'yes\' in item no 11, number of employees received formal training'}</h6>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="trainingMaleEmployees">11.1 {storedLanguage === 'hi' ? 'पुरुष' : 'Male'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="trainingMaleEmployees"
                              name="trainingMaleEmployees"
                              maxLength="6"
                              value={formData.trainingMaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="trainingFemaleEmployees">11.2 {storedLanguage === 'hi' ? 'महिला' : 'Female'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="trainingFemaleEmployees"
                              name="trainingFemaleEmployees"
                              maxLength="6"
                              value={formData.trainingFemaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <label htmlFor="trainingTransgenderEmployees">11.3 {storedLanguage === 'hi' ? 'ट्रांसजेंडर' : 'Transgender'}</label>
                            <input 
                              type="text" 
                              className="form-control"
                              id="trainingTransgenderEmployees"
                              name="trainingTransgenderEmployees"
                              maxLength="6"
                              value={formData.trainingTransgenderEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                        </>
                      );
                    }
                    return null;
                  })()}
                  
                  {/* GSTIN - Show only for 2024-2025 */}
                  {(() => {
                    const is2024Year = !formData.surveyYear || formData.surveyYear === 2024 || formData.surveyYear === '2024';
                    
                    if (is2024Year) {
                      return (
                        <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                          <label htmlFor="gstin">12. {storedLanguage === 'hi' ? 'माल और सेवा कर पहचान संख्या (GSTIN)' : 'Goods and Services Tax Identification Number (GSTIN)'}</label>
                          <input 
                            type="text" 
                            className="form-control"
                            id="gstin"
                            name="gstin"
                            maxLength="15"
                            value={formData.gstin}
                            onChange={handleChange}
                            placeholder="GSTIN (15 characters)"
                          />
                        </div>
                      );
                    }
                    return null;
                  })()}
              
              </div>
          
              <div className="row">
                <div className="col-12">
                  <hr/>
                </div>
            
                <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
                      <button 
                      type="submit" 
                      className="btn btn_orange me-1"
                      onClick={()=>{ window.print()}}
                      >Print 
                      <i className="fa fa-print ms-1"></i>
                      </button>

                      <button 
                      type="button" 
                      className="btn btn_orange me-1"
                      onClick={(e)=>{handleSaveData("SAVE")}}
                      disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}>
                      Save
                     </button>

                      <button 
                      type="reset" 
                      className="btn btn_orange me-1"
                      onClick={handleReset}
                      >
                      Reset
                     </button>

                      <button 
                      type="button" 
                      className="btn btn_orange"
                      onClick={(e)=>( navigate("/dashboard"))}
                      >
                      Cancel
                    </button>

                </div>
              
                <div className="col-lg-4 text-center text-lg-end">
                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
                  >
                  <i className="fa fa-angle-left me-1"></i> 
                  Previous
                 </button>

                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handleNext}
                  disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
                  >
                  Next 
                  <i className="fa fa-angle-right ms-1"></i>
                </button>

                </div>
                        
              </div>
       </div>
  )
}

export default BlockB